// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import styled from 'styled-components';
import Button from '../../components/Button';
import Column from '../../components/Column';

const S = {
  Wrapper: styled(Column)`
    width: 100%;
    margin-top: -20px;
    margin-bottom: 0px;
    position: relative;
    justify-content: space-between;
    align-items: center;
  `,
  Img: styled.img`
    width: 220px;
    height: 220px;
  `,
  LoginButton: styled(Button)`
    min-width: 112px;
    padding: 9px 20px;
    height: 44px;
    background: #FFFFFF;
    border: 1px solid #C9C9C9;
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 18px;
    line-height: 26px;
    text-align: center;
    color: #EF8200;
    box-shadow: revert;
    padding: 7px 11px;
    margin-right: 20px;
    &:hover {
      color: white;
    }
  `,
  Wait30Description: styled.div`
    font-size: 14px;
    line-height: 20px;
    color: #FE4747;
    margin-top: 9px;
    align-items: center;
    justify-content: center;
  `,
  RetryButton: styled(Button)`
    min-width: 112px;
    margin-left: 20px;
    height: 44px;
    font-size: 18px;
    line-height: 26px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    background: #EF8200;
    border-radius: 4px;
    box-shadow: revert;
    padding: 9px 20px;
  `,
  Title: styled.div`
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    color: #434343;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  Description: styled.div`
    font-size: 16px;
    line-height: 23px;
    max-width: 233px;
    color: #666666;
    margin-top: 9px;
    align-items: center;
    justify-content: center;
  `,
  DescriptionWrapper: styled.div`
    font-size: 16px;
    line-height: 23px;
    color: #434343;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    justify-content: center;
  `,
  ButtonWrapper: styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 10px;
  `
}
export { S as default }
